import React,{useState,useEffect} from 'react';
import { Navbar, Nav, Carousel, Modal, Image, Offcanvas} from 'react-bootstrap';
import { useLanguage } from '../i18n/LanguageContext';
import { loadAndParseXml } from '../i18n/xmlLoader';

function Card(props){
  const { language, t } = useLanguage();
  const [show, setShow] = useState(props.show);
  const [index, setIndex] = useState(0);
  var card = props.card;
  var title, summary, commentary;

  if (card != null && card  != "0"){
    loadAndParseXml(card + ".xml", language, function (err, result) {
      if (err || !result || !result.card) return;
      title = Array.isArray(result.card.title) ? result.card.title[0] : result.card.title;
      summary = Array.isArray(result.card.summary) ? result.card.summary[0] : result.card.summary;
      commentary = Array.isArray(result.card.commentary) ? result.card.commentary[0] : result.card.commentary;
    });
  }
  

  function handleClose(){
    setShow(false);
    props.onHide();
  } 

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  
  function getOffCanvas(){
    return (
      <Offcanvas show={show} onHide={handleClose} {...props}>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>{title}</Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body style={{paddingTop:0}}>
      <div style={{overflowY:'auto', textAlign:'center'}}>
        <div><Image src={currentCardPath} thumbnail style={{overflow:'hidden', height: 'calc(100vh - 230px - env(safe-area-inset-top) - env(safe-area-inset-bottom)) * 0.7', maxHeight:'600px', minHeight:'300px', minWidth:'250px', width:'calc((100vh - 230px - env(safe-area-inset-top) - env(safe-area-inset-bottom))*0.7 * 0.7)'}} /></div>
        <p></p>
        <div style={{textAlign:'left'}}>{summary}</div>
          <p></p>
          <p><b style={{color:'black'}}>{t('common.commentary')}</b></p>
          <div style={{textAlign:'left'}}>{commentary}</div>
      </div>
    </Offcanvas.Body>
  </Offcanvas>
    )
  }
  var currentCardPath = "cards/" + card + ".jpg";

  const handleShow = () => setShow(true);


  return (
    getOffCanvas()
  )
};

export default Card;